import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** play triangle. Decorative line icon; always pair with a visible text label. */
export function PlayIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M8 5.4l11 6.6-11 6.6V5.4z" />
    </IconSvg>
  )
}
